import { Icon, useSidebar } from "@elit-hair/elit-ui";
import { useTranslation } from "react-i18next";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";

import { cn } from "@/lib/utils";

/**
 * Edge affordance on the left sidebar.
 * Appears when hovering anywhere on the sidebar: a vertical line with a floating chevron to toggle collapse.
 */
export function SidebarEdgeToggle() {
    const { t } = useTranslation();
    const { state, toggleSidebar } = useSidebar();
    const isCollapsed = state === "collapsed";

    return (
        <button
            type="button"
            onClick={toggleSidebar}
            aria-label={isCollapsed ? t("expand_sidebar") : t("collapse_sidebar")}
            title={isCollapsed ? t("expand_sidebar") : t("collapse_sidebar")}
            className={cn(
                "group/edge-btn absolute inset-y-0 right-0 z-30 flex w-3 translate-x-1/2 items-center justify-center",
                "cursor-w-resize border-0 bg-transparent p-0",
                isCollapsed && "cursor-e-resize"
            )}
        >
            <span
                aria-hidden
                className="pointer-events-none absolute inset-y-0 left-1/2 w-px -translate-x-1/2 bg-border opacity-0 transition-opacity duration-150 group-hover:opacity-100 group-focus-visible/edge-btn:opacity-100"
            />
            <span
                aria-hidden
                className={cn(
                    "cursor-pointer absolute top-[8%] left-1/2 z-10 flex h-6 w-6 -translate-x-1/2 -translate-y-1/2 items-center justify-center",
                    "rounded-full border border-border bg-background text-muted-foreground shadow-sm",
                    "opacity-0 transition-opacity duration-150",
                    "group-hover:opacity-100 group-focus-visible/edge-btn:opacity-100"
                )}
            >
                <Icon icon={isCollapsed ? TbChevronRight : TbChevronLeft} size={14} />
            </span>
        </button>
    );
}
